<!-- 基地排车 -->
<template>
    <paper class="base-platoon">
        <mPane
            ref="tablePage"
            class="base-platoon-mPane"
            pageID="base_rlatoon"
            searchId="base_rlatoon_query"
            :config="config"
            :totalData="totalData"
            :totalTargetData="totalTargetData"
            :loading="loading"
            :targetTableLoading="targetTableLoading"
            :searchTotalTitle="config.table.searchTotalTitle"
            :mulSourceSel="true"
            :sourceRootData="sourceTree"
            :targetRootData="targetTree"
            :optionNum="optionNum"
            :columnNum="columnNum"
            :isRefreshTarget="true"
            :sourceTitle="'待调度'"
            :targetTitle="targetTitle"
            @searchChange="searchChange"
            @allocate-btn="allocateBtn"
            @root-click="rootClick"
            @source-select-change="sourceSelChange"
            @target-select-change="targetSelChange"
            @search-input="searchInput"
            @sourceCellDblclick="sourceCellDblclick"
            @targetCellDblclick="targetCellDblclick"
            @sourceSelect="sourceSelect"
            @sourceRowClick="sourceRowClick"
            @sourceSelectAll="sourceSelectAll"
            @targetRowClick="targetRowClick"
            @targetSelect="targetSelect"
            @targetSelectAll="targetSelectAll"
            @refreshTarget="refreshTargetList"
            @toVisualDispatchCenter="toVisualDispatchCenter"
        >
            <!-- 搜索栏右侧上表格勾选数据单位展示 -->
            <template slot="table-top">
                <div style="margin-bottom: 8px;">
                    <span class="left-info collect">
                        <span class="content">单量:&nbsp;&nbsp;&nbsp;{{filterCheckedSourceListCount}}</span>
                        <span class="content">数量:&nbsp;&nbsp;&nbsp;{{taskTotalCount}}</span>
                        <span class="content">方量(m³):&nbsp;&nbsp;&nbsp;{{taskTotalVolume}}</span>
                        <span class="content">重量(KG):&nbsp;&nbsp;&nbsp;{{taskTotalWeight}}</span>
                        <span
                            class="content"
                            v-show="totalPkgQtys"
                        >总包件数:&nbsp;&nbsp;&nbsp;{{totalPkgQtys}}</span>
                    </span>
                </div>
            </template>
            <!-- 搜索栏右侧上表格勾选数据单位展示 -->

            <!-- 搜索栏右侧按钮插槽 -->
            <template slot="table-module-btn">
                <header-btn :checkedSourceList="realCheckedSourceList" @refreshList="refreshList"></header-btn>
            </template>
            <!-- 搜索栏右侧按钮插槽 -->

            <!-- 上表格展开行插槽 -->
            <template slot="expand-table-cont" slot-scope="{ expandTable }">
                <expand-table-content
                    :contentTableData="expandTable"
                    :columnsList="expandTableHeader"
                ></expand-table-content>
            </template>
            <!-- 上表格展开行插槽 -->

            <!-- 下表格头部 -->
            <template slot="target-table-header">
                <div class="target-table-header" @mousedown.stop.prevent="mousedownTabelHeight">
                    <DispaHeader
                        :tarSelRoot="tarSelRoot"
                        :mulTotalData="mulTotalData"
                        :realTotalTargetData="realTotalTargetData"
                        :totalTargetData="totalTargetData"
                        :cheList="realCheList"
                        :checkedSourceList="realCheckedSourceList"
                        :confDisable="confirmDisable"
                        :groupPolicyCode="groupPolicyCode"
                        :groupPolicyValArr="groupPolicyValArr"
                        :sourceTree="sourceTree"
                        :currWarehouseGroup="currWarehouseGroup"
                        :currInOutType="currInOutType"
                        @newDispOrder="newDispOrder"
                        @arraVisi="arraVisi"
                        @setBoxSort="getBoxSort"
                        @arrangeConfirmOk="arrangeConfirmOk"
                        @totalDataChange="totalDataChange"
                    ></DispaHeader>
                </div>
            </template>
            <!-- 下表格头部 -->
        </mPane>

        <!-- 分拨弹窗 -->
        <distribution
            v-if="tableVisible"
            :tableVisible.sync="tableVisible"
            :rowData="rowData"
            ref="distributionRef"
            @distributionOk="distributionOk"
        ></distribution>
        <!-- 分拨弹窗 -->

        <!-- 排车调度弹窗 -->
        <car-scheduling-dialog
            ref="carScheduling"
            label-position="right"
            :carrierDisabled="carrierDisabled"
            :RwCarVisiable.sync="arrangeSubmVisi"
            v-if="arrangeSubmVisi"
            :inOutType="currInOutType"
            :taskDataList="taskDataList"
            @AdmittOk="arrangeSubmOk"
        ></car-scheduling-dialog>
        <!-- 排车调度弹窗 -->

        <!-- 撤回弹窗 -->
        <!-- 撤回弹窗 -->
    </paper>
</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import { mapState } from 'vuex';
import paper from '@/components/core/paper/Paper';
import mPane from '../../../components/mPanel';
import HeaderBtn from './component/HeaderBtn.vue';
import Distribution from './dialog/Distribution';
import DispaHeader from './component/DispaHeader.vue';
import ExpandTableContent from './component/ExpandTableContent.vue';
// import carSchedulingDialog from '../../../components/dialog/carSchedulingDialog';
import carSchedulingDialog from './dialog/carSchedulingDialog.vue';
import { groupPolicyObj, dispatchCenterRowCarCheck, addOrderCheck, verifyLBX, verifyLBXOrder, getMesTip, minusVerifyLBXOrder } from '../../../utils/dispatchCenter.js';
import formatTime from '@/utils/common.js';
import { Sortable } from 'sortablejs';
import { dictWithUrl } from '@/components/lots/api.js';
import { getTargetRoot, getSourceData, getTargetData, getSourceRoot, dispatchTrunkSave, loadSeqUpdateByTaskNo } from '../../../api/basePlatoon';
import {
    saveCarArrange,
    getTransferData,
    intelligentDispatch,
    appointment,
    promptTrackType
} from '../../../api/dispatchCenter';
import { initTableData, optionNum, searchFieldSeperated } from './util.js';
import config from './config.json';
import bigDataLog from '@/utils/bigDataLog';

const PRIVILEGE_MOVE_CODE = '040100016';
const MAX_SHOW_COUNT = 500; // 默认表格最多只给他展示500条
const TARGER_TABLE_MAX_SHOW_COUNT = 500; // 下面表格给他最多展示的数量
const DISPATCH_STATUS_IN_TRANSIT = 40; // 发车单状态-在途

export default {
    name: 'dispatchManageBasePlatoon',
    components: {
        paper,
        mPane,
        HeaderBtn,
        Distribution,
        DispaHeader,
        ExpandTableContent,
        carSchedulingDialog
    },
    data () {
        return {
            config,
            optionNum, // 数据字典
            dictData: {}, // 数据字典参数集合
            /* 上 下表格 */
            loading: false, // 上表格loading
            columnNum: 20, // 上表格列配置限制个数
            totalData: [], // 页面展示的上表格数据
            mulTotalData: [], // 真正的上表格数据
            checkedSourceList: [], // 上表格选中数据集合
            currentSourceSelectRow: {}, // 上表格选中数据(当前选中--单个)
            expandTableHeader: [ // 上表格张凯航插槽配置
                { label: '客户商品编码', prop: 'customerItemCode', width: 180 }, { label: '商品编码', prop: 'itemCode', width: 180 },
                { label: '名称', prop: 'itemName', width: 180 }, { label: '商品分类名称', prop: 'itemClassName', width: 180 }, { label: '预计发数量', prop: 'unitQty', width: 100 },
                { label: '商品重量', prop: 'weight', width: 100 }, { label: '商品方量', prop: 'volume', width: 100 }
            ],
            targetTableLoading: false, // 下表格loading
            targetTotalListPage: { // 下表格搜索总页数数据
                pageNo: 1,
                pageSize: 1000000,
                total: 0
            },
            totalTargetData: [], // 下表格参数集合
            realTotalTargetData: [], // 真正的下表格数据
            cheList: [], // 下表格选中数据集合
            currentSelectRow: {}, // 下表格选中数据(当前选中--单个)
            endMoveHeight: 0, // 上表格和下表格自适应高度
            targetIsAllSel: false, // 下表格是否点击全选，因为有天猫优品勾选一单选中所有相同客户订单号只展示100单判断真实选中会不准确
            sourceIsAllSel: false, // 同上，上表格类似逻辑
            rowData: {}, // 存储分拨数据
            tableVisible: false, // 分拨弹窗开关
            pageTotal: 100,
            /* 上 下表格 */
            /* 待调度 待发车 */
            groupPolicy: '', // 分组策略
            groupPolicyCode: '', // 分组策略code
            sourceTree: [], // 待调度列表参数集合
            targetTree: [], // 待发车列表参数集合
            searchParams: {}, // 待调度搜索参数集合
            sourceSelectedRoot: {}, // 待调度列表点击参数存储
            targetTotalListParams: { // 待发车搜索参数集合
                dispatchStatus: '0,10,20,30',
                trunk: true, // 是否查询基地运单
            },
            tarSelRoot: {}, // 待发车列表点击参数存储
            /* 待调度 待发车 */
            /* 下表格头部 */
            confirmDisable: false, // 下表格头部确认按钮
            groupPolicyValArr: [], // 待调度选中参数(与分组策略code对应)code集合
            taskDataList: [], // 传进排车页面进行校验的tk单
            arrangeSubmVisi: false, // 排车调度弹窗开关
            carrierDisabled: false // 排车时承运商是否能修改
            /* 下表格头部 */
        };
    },
    computed: {
        ...mapState({
            supplier: state => state.supplier,
            currentTenant: state => state.currentTenant
        }),
        realCheckedSourceList: function () {
            if (this.checkedSourceList.length === this.totalData.length && this.sourceIsAllSel) {
                return this.mulTotalData;
            }
            return minusVerifyLBXOrder(this.checkedSourceList, this.mulTotalData);
        },
        realCheList: function () {
            if (this.cheList.length === this.totalTargetData.length && this.targetIsAllSel) {
                return this.realTotalTargetData;
            }
            return minusVerifyLBXOrder(this.cheList, this.realTotalTargetData);
        },
        taskTotalVolume: function () {
            return this.realCheckedSourceList.reduce((partical, value) => {
                const taskTotalVolume = partical + (value.totalVolume || 0);
                return Math.round(taskTotalVolume * 1000000) / 1000000;
            }, 0);
        },
        taskTotalWeight: function () {
            return this.realCheckedSourceList.reduce((partical, value) => {
                const taskTotalWeight = partical + (value.totalGrossWeight || 0);
                return Math.round(taskTotalWeight * 1000) / 1000;
            }, 0);
        },
        taskTotalCount: function () {
            return this.realCheckedSourceList.reduce((partical, value) => {
                const taskTotalCount = partical + (value.totalQty || 0);
                return Math.round(taskTotalCount * 1000) / 1000;
            }, 0);
        },
        filterCheckedSourceListCount: function () {
            return this.realCheckedSourceList.length;
        },
        targetTitle: function () {
            return `待发车(${this.targetTree.length || 0})`;
        },
        currWarehouseGroup: function () {
            return this.totalTargetData[0] && this.totalTargetData[0].warehouseGroup;
        },
        currInOutType: function () {
            return this.totalTargetData[0] && this.totalTargetData[0].inOutType;
        },
        totalPkgQtys: function () {
            return this.checkedSourceList.reduce((partical, value) => {
                if (value.projectClassify === 'HL') {
                    const totalPkgQtys = partical + (value.totalPkgQty || 0);
                    return Math.round(totalPkgQtys * 1000) / 1000;
                }
            }, 0);
        },
        isPrivilege: function () { // 加入发车单/移除发车单 时使用，特权模式
            const auths = this.$_has(PRIVILEGE_MOVE_CODE);
            return auths;
        }
    },
    mounted () {
        this.getDictList();
        this.rowDrop();
    },
    methods: {
        // 获取数据字典
        async getDictList () {
            const dict = await dictWithUrl(this.optionNum);
            this.dictData = dict.data;
        },
        /* 上 下表格数据拖动 */
        rowDrop () {
            const sourceTbody = document.querySelector(
                '.source-table .el-table__body-wrapper tbody'
            );
            const _this = this;
            this.sortInst = Sortable.create(sourceTbody, {
                group: {
                    name: 'source',
                    pull: true,
                    put: 'target' // 可拖出
                },
                sort: false, // 禁止表内排序
                multiDrag: true,
                onEnd: ({ newIndex, oldIndex, from, to, item }) => {
                    const oldSourceInx = oldIndex;
                    if (from !== to) {
                        // 处理展开详情index顺序乱掉问题
                        if (item.className === '') {
                            oldIndex = oldSourceInx - 1;
                        } else {
                            const trs = from.getElementsByTagName('tr');
                            let trIndex = '';
                            for (let i = 0; i < trs.length; i++) {
                                if (trs[i].className === '') {
                                    trIndex = i;
                                }
                            }
                            if (trIndex === '') {
                                oldIndex = oldSourceInx;
                            } else if (trIndex < oldIndex) {
                                oldIndex = oldSourceInx - 1;
                            }
                        }
                        item.remove();
                        const rows2Transfer = _this.realCheckedSourceList.length > 1 ? _this.realCheckedSourceList : [_this.totalData[oldIndex]];
                        const clone = _this.totalData;
                        _this.totalData = [];
                        for (let i = 0; i < rows2Transfer.length; i++) {
                            let warningMsg = '';
                            if (this.isPrivilege && rows2Transfer[i].logisticMode === 'WT' && rows2Transfer[i].scanNum > 0 && +rows2Transfer[i].dispatchType !== 0) {
                                warningMsg = '直通宝已扫码，请在直通宝完成后续操作';
                            } else if (rows2Transfer.some(item => {
                                return item.logisticMode === 'WT' && item.checkWmsStatus === 'Y' && (!item.wmsStatus || +item.wmsStatus < 300);
                            })) {
                                warningMsg = '仓配分离订单配置了波次后加单不允许待拣货前订单加单，请核实W状态是否为波次后';
                            } else if (rows2Transfer.some(row => +row.arriveAppointmentRequireFlag === 2 && !row.appointmentTime)) {
                                warningMsg = '存在强制预约的客户订单，需要预约派送时间!';
                            };
                            if (warningMsg) {
                                _this.timerAllDiff = setTimeout(() => {
                                    _this.$nextTick(() => {
                                        _this.totalData = clone;
                                    });
                                }, 100);
                                return this.$message.warning(warningMsg);
                            }
                        }
                        const realTotalData = this.mulTotalData;
                        let rowCarCheckRes = '';
                        const verifyLBXRes = verifyLBX(rows2Transfer, realTotalData);
                        clearTimeout(_this.timerAllDiff);
                        clearTimeout(_this.timerDragLoad);
                        if (_this.realTotalTargetData.length <= 0) {
                            rowCarCheckRes = dispatchCenterRowCarCheck(rows2Transfer);
                        } else {
                            rowCarCheckRes = dispatchCenterRowCarCheck(_this.realTotalTargetData);
                            if (!rowCarCheckRes) rowCarCheckRes = dispatchCenterRowCarCheck(rows2Transfer, _this.realTotalTargetData[0], _this.realTotalTargetData);
                            if (!rowCarCheckRes) rowCarCheckRes = addOrderCheck(_this.realTotalTargetData, rows2Transfer);
                        }
                        _this.timerAllDiff = setTimeout(() => {
                            _this.$nextTick(() => {
                                if (rowCarCheckRes) {
                                    _this.totalData = clone;
                                    return _this.$message.warning(rowCarCheckRes);
                                } else if (_.isPlainObject(verifyLBXRes)) {
                                    _this.totalData = clone;
                                    return getMesTip(verifyLBXRes, _this);
                                } else {
                                    _this.realTotalTargetData = [
                                        ...verifyLBXRes,
                                        ..._this.realTotalTargetData
                                    ];
                                    // 满帮校验,当选中的运单中存在渠道为【满帮】的运单和空渠道的运单时
                                    if (rows2Transfer.some(item => +item.wdqd === 1)) {
                                        this.$confirm('该批运单存在已发布至满帮叫车，请确认是否进行新的运单移入?', '提示', {
                                            confirmButtonText: '确定',
                                            cancelButtonText: '取消',
                                            type: 'warning'
                                        }).then(() => {
                                            // 当选中的运单中同为【满帮】运单，但是货源ID不一致时
                                            if ([...new Set(rows2Transfer.map(item => item.cargoId))].length > 1) {
                                                this.$message.warning('选中了多条满帮货源发布的运单，请核实后重新进行筛选');
                                            }
                                            _this.totalTargetData = this.getTotalData(_this.realTotalTargetData, TARGER_TABLE_MAX_SHOW_COUNT);
                                            const transTaskNo = verifyLBXRes.map(el => el.taskNo);
                                            this.mulTotalData = this.mulTotalData.filter(el => !transTaskNo.includes(el.taskNo));
                                            _this.totalData = this.getTotalData(this.mulTotalData);
                                        }).catch(() => {
                                            _this.totalData = clone;
                                            _this.realTotalTargetData = [];
                                            return false;
                                        });
                                    } else {
                                        _this.totalTargetData = this.getTotalData(_this.realTotalTargetData, TARGER_TABLE_MAX_SHOW_COUNT);
                                        const transTaskNo = verifyLBXRes.map(el => el.taskNo);
                                        this.mulTotalData = this.mulTotalData.filter(el => !transTaskNo.includes(el.taskNo));
                                        _this.totalData = this.getTotalData(this.mulTotalData);
                                    }
                                }
                            });
                        }, 100);
                    }
                }
            });
            const targetTbody = document.querySelector(
                '.target-table .el-table__body-wrapper tbody'
            );
            Sortable.create(targetTbody, {
                group: {
                    name: 'target',
                    pull: true,
                    put: 'source' // 可放置来自source组的拖拽
                },
                sort: false,
                multiDrag: true,
                onEnd: ({ newIndex, oldIndex, from, to, item }) => {
                    const oldTargetInx = oldIndex;
                    this.groupPolicyValArr = [];
                    if (from !== to) {
                        // 处理展开详情index顺序乱掉问题
                        if (item.className === '') {
                            oldIndex = oldTargetInx - 1;
                        } else {
                            const trs = from.getElementsByTagName('tr');
                            let trIndex = '';
                            for (let i = 0; i < trs.length; i++) {
                                if (trs[i].className === '') {
                                    trIndex = i;
                                }
                            }
                            if (trIndex === '') {
                                oldIndex = oldTargetInx;
                            } else if (trIndex < oldIndex) {
                                oldIndex = oldTargetInx - 1;
                            }
                        }
                        const targetTabelData = _this.realCheList.length > 1 ? _this.realCheList : [_this.totalTargetData[oldIndex]];
                        const targetClone = _this.totalTargetData;
                        _this.totalTargetData = [];
                        clearTimeout(this.timerUpDrag);
                        this.timerUpDrag = setTimeout(() => {
                            _this.$nextTick(() => {
                                if (+this.tarSelRoot.gainingContract) {
                                    _this.$message.warning('获取合同号中，不可以加单');
                                    _this.totalTargetData = targetClone;
                                } else {
                                    for (let i = 0; i < targetTabelData.length; i++) {
                                        if (targetTabelData[i].logisticMode !== 'WT' && +targetTabelData[i].taskStatus === 30 &&
                                            targetTabelData[i].dispatchNo && ['YS', 'OUT'].includes(targetTabelData[i])
                                        ) {
                                            _this.totalTargetData = targetClone;
                                            return this.$message.warning(`存在不能减单的运输单：${targetTabelData[i].taskNo}`);
                                        }
                                        if (this.isPrivilege && targetTabelData[i].logisticMode === 'WT' && targetTabelData[i].taskStatus >= DISPATCH_STATUS_IN_TRANSIT) {
                                            return this.$message.warning(`仓配分离运输单：${targetTabelData[i].taskNo} 是在途前的状态才能减单`);
                                        }
                                    }
                                    const minusVerifyLBXOrderRes = minusVerifyLBXOrder(targetTabelData, this.realTotalTargetData);
                                    const targetDataTaskNo = minusVerifyLBXOrderRes.map(el => el.taskNo);
                                    this.realTotalTargetData = this.realTotalTargetData.filter(el => !targetDataTaskNo.includes(el.taskNo));
                                    _this.totalTargetData = this.getTotalData(this.realTotalTargetData, TARGER_TABLE_MAX_SHOW_COUNT);
                                    const currentGroupPolicyData = []; // 在当前分组下要拖的数据
                                    this.groupPolicyValArr = [];
                                    // 多选功能下选中的待调度的分组
                                    this.sourceTree.forEach(item => {
                                        if (item.isActive) this.groupPolicyValArr.push(item[this.groupPolicyCode]);
                                    });
                                    minusVerifyLBXOrderRes.forEach(item => {
                                        if (this.groupPolicyValArr.includes(item[this.groupPolicyCode])) currentGroupPolicyData.push(item);
                                    });
                                    const curGrototalDataClone = [].concat(_this.mulTotalData);
                                    const targetTabelTask = curGrototalDataClone.map(el => el.taskNo);
                                    currentGroupPolicyData.forEach(item => {
                                        if (this.groupPolicyValArr.length === 0) {
                                            _this.mulTotalData = [];
                                        } else if (this.groupPolicyValArr.includes(item[this.groupPolicyCode]) && !targetTabelTask.includes(item.taskNo)) {
                                            _this.mulTotalData.unshift(item);
                                        }
                                    });
                                    _this.totalData = this.getTotalData(_this.mulTotalData);
                                }
                            });
                        }, 80);
                    }
                }
            });
        },
        /* 上 下表格数据拖动 */
        /* mPane回调事件 SATRT */
        // 搜索
        async searchChange (data) {
            if (data.createTime && data.createTime.length > 0) {
                data.beginDate = formatTime.formatDateTime(data.createTime[0]);
                data.endDate = formatTime.formatDateTime(data.createTime[1]);
            } else if (!data.createTime && !data.beginDate) {
                data.beginDate = '';
                data.endDate = '';
            }
            // 要求发货时间
            if (data.requireOutTime && data.requireOutTime.length > 0) {
                data.requireOutTimeStart = formatTime.formatDateTime(data.requireOutTime[0]);
                data.requireOutTimeEnd = formatTime.formatDateTime(data.requireOutTime[1]);
            } else if (!data.requireOutTime && !data.requireOutTimeStart) {
                data.requireOutTimeStart = '';
                data.requireOutTimeEnd = '';
            }
            if (data.departureTime && data.departureTime.length > 0) {
                data.beginDate1 = data.departureTime[0];
                data.endDate1 = data.departureTime[1];
            } else if (!data.departureTime && !data.beginDate1) {
                data.beginDate1 = '';
                data.endDate1 = '';
            }
            if (data.requireArriveTime && data.requireArriveTime.length > 0) {
                data.requireArriveTimeBegin = data.requireArriveTime[0];
                data.requireArriveTimeEnd = data.requireArriveTime[1];
            } else if (!data.requireArriveTime && !data.requireArriveTimeBegin) {
                data.requireArriveTimeBegin = '';
                data.requireArriveTimeEnd = '';
            }

            if (data.custOrderNo) {
                data.custOrderNos = data.custOrderNo.split(',');
            } else {
                data.custOrderNos = [];
            }
            if (data.carrierCode) {
                data.carrierCodes = data.carrierCode.split(',');
            } else {
                data.carrierCodes = [];
            }
            if (data.waveId) {
                data.waveIdList = data.waveId.split(',');
            } else {
                data.waveIdList = '';
            }
            delete data.waveId;
            delete data.custOrderNo;
            delete data.createTime;
            delete data.requireOutTime;
            delete data.departureTime;
            delete data.requireArriveTime;
            const startTime = data.beginDate || 0;
            const endTime = data.endDate || 0;
            const timeDifference = new Date(endTime).getTime() - new Date(startTime).getTime();
            // 处理时间跨度1个月
            const start = dayjs().subtract(1, 'months').format('YYYY-MM-DD') + ' 00:00:00';
            const end = dayjs().format('YYYY-MM-DD') + ' 23:59:59';
            const newtTimeDifference = new Date(end).getTime() - new Date(start).getTime();
            if (!data.custOrderNos.length && !startTime) {
                return this.$message.warning('客户订单号 和 创建时间 不可同时为空');
            } else if (!data.custOrderNos.length && startTime) {
                if (timeDifference > newtTimeDifference) {
                    return this.$message.warning('按时间查询时，查询时间跨度不可超过一个月！');
                }
            }
            // 事业部集拼单号可多个查询（限制30个）
            let assembleNoList = [];
            if (data.assembleNo) {
                assembleNoList = data.assembleNo.split(',');
                if (assembleNoList.length > 30) {
                    return this.$message.warning('事业部集拼单号最多只能输入30个');
                }
                delete data.assembleNo;
                data.assembleNos = assembleNoList;
            } else {
                data.assembleNos = [];
            }
            if (data.appointmentTimeReleased && !(/^[1-9]\d*$/).test(data.appointmentTimeReleased)) {
                return this.$message.warning('预约释放时间只能填正整数！');
            }
            this.totalData = [];
            this.mulTotalData = [];
            // this.totalTargetData = [];
            if (data.groupPolicy) this.groupPolicy = data.groupPolicy;
            data.taskStatus = '0';
            this.searchParams = {
                ...this.searchParams,
                ...data
            };
            if (this.searchParams.siteCode) {
                this.searchParams.querySiteCodes = this.searchParams.siteCode.split(',');
                // delete this.searchParams.siteName;
                // delete this.searchParams.siteCode;
            } else {
                this.searchParams.querySiteCodes = [];
            }
            this.searchParams.whCodeList = this.searchParams.whCode ? this.searchParams.whCode.split(',') : [];
            delete this.searchParams.whCode;
            delete this.searchParams.whName;
            for (const key in this.searchParams) {
                if (!this.searchParams[key].length) {
                    delete this.searchParams[key];
                }
            }
            await this.getSourceList();
            await this.getTargetList();
            this.$refs.tablePage.initActiveChange();
        },
        // 获取待调度列表数据
        async getSourceList () {
            this.$refs.tablePage.changeLoading(true);
            this.$refs.tablePage.sourceTreeLoading = true;
            const supplierCode = this.supplier.supplierCode;
            await getSourceRoot({
                ...this.searchParams,
                trunk: true, // 是否查询基地运单
                carrierVisibleFlag: 'Y',
                carrierCodes: [supplierCode] // 具体的承运商编码
            }).then(resp => {
                this.$refs.tablePage.changeLoading(false);
                this.$refs.tablePage.sourceTreeLoading = false;
                if (resp) {
                    const sourceTree = resp.data.list;
                    if (sourceTree) {
                        sourceTree.forEach(root => {
                            root.isActive = false;
                            root['textLeft'] =
                                `${root[this.groupPolicy] ? root[this.groupPolicy] : ' '} ${root.totalVolume || ''}m³/${root.totalWeight || ''}KG/${root.totalQty || ''}台/${root.taskCount || ''}单`;
                        });
                    }
                    this.sourceTree = sourceTree;
                }
            }).finally(() => {
                this.$refs.tablePage.changeLoading(false);
                this.$refs.tablePage.sourceTreeLoading = false;
            });
        },
        // 获取待发车列表数据
        async getTargetList (isClick) {
            this.$refs.tablePage.targetTreeLoading = true;
            const supplierCode = this.supplier.supplierCode;
            this.targetTotalListParams.carrierCode = supplierCode; // 具体的承运商编码
            await getTargetRoot(this.targetTotalListParams).then(res => {
                if (res) {
                    const targetTree = res.data.list || [];
                    if (targetTree) {
                        targetTree.forEach(root => {
                            if (+root.intelligentFlag !== 0) {
                                if (+root.intelligentStatus === 10) {
                                    root['html'] = `<span class="left-doted"> 智能排车中...`;
                                } else {
                                    root['html'] = `<span class="left-doted">${root.vehicleCard} ${root.volume}m³/${root.totalWeight}KG/${Math.round(root.loadRate * 100)}%`;
                                }
                            } else {
                                root['html'] = `${root.vehicleCard} ${root.volume}m³/${root.totalWeight}KG/${Math.round(root.loadRate * 100)}%`;
                            }
                        });
                    }
                    this.targetTree = this.tempTargetTree = targetTree;
                    if (isClick) {
                        this.$nextTick(() => {
                            this.targetTree[0] && this.$refs.tablePage.rootListClick(this.targetTree[0], 'target', 0);
                        });
                    }
                }
            }).finally(() => {
                this.$refs.tablePage.targetTreeLoading = false;
            });
        },
        // 分拨
        allocateBtn (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-allocation');
            this.rowData = Object.assign({}, data);
            const verifyLBXOrderRes = verifyLBXOrder([data]);
            if (!getMesTip(verifyLBXOrderRes, this)) { this.tableVisible = true; }
        },
        // 分拨弹窗事件回调
        distributionOk () {
            this.tableVisible = false;
            this.$refs.tablePage.$refs.searchList.onSearchChange();
        },
        // 待调度 待发车数据列表点击事件
        rootClick (item, to) {
            if (to === 'source') {
                this.sourceSelectedRoot = item;
                this.initTransportList();
            }
            if (to === 'target') {
                this.tarSelRoot = item;
                if (+this.tarSelRoot.intelligentStatus === 10) {
                    this.confirmDisable = true;
                } else if (+this.tarSelRoot.intelligentStatus === 30) {
                    this.confirmDisable = false;
                }
                this.initDispatchList();
            }
        },
        // 根据待调度列表点击参数获取上表格数据
        initTransportList () {
            this.$refs.tablePage.sourceLoading = true;
            const data = Object.assign({}, this.searchParams, { pageSize: 1000 });
            const supplierCode = this.supplier.supplierCode;
            groupPolicyObj.forEach(item => {
                if (item.name === this.groupPolicy) {
                    this.groupPolicyCode = item.code;
                    data[item.code] = this.sourceSelectedRoot[item.code] || '';
                }
            });
            data.taskNos = this.sourceSelectedRoot.taskNos.split(',');
            getSourceData({
                ...data,
                trunk: true, // 是否查询基地运单
                carrierVisibleFlag: 'Y',
                carrierCodes: [supplierCode] // 具体的承运商编码
            }).then(async resp => {
                this.$refs.tablePage.sourceLoading = false;
                if (resp) {
                    this.sourceSelectedRoot.isActive = !this.sourceSelectedRoot.isActive;
                    const resData = resp.data.list || [];
                    if (this.sourceSelectedRoot.isActive) {
                        this.mulTotalData = this.mulTotalData.concat(resData);
                    } else {
                        const resDataGroupPolicyCode = resData.map(el => el[this.groupPolicyCode]);
                        this.mulTotalData = this.mulTotalData.filter(el => !resDataGroupPolicyCode.includes(el[this.groupPolicyCode]));
                    }
                    let btnCount = 0;
                    const totalTargetDataTaskNo = this.realTotalTargetData.map(el => el.taskNo);
                    this.mulTotalData = this.mulTotalData.filter(el => !totalTargetDataTaskNo.includes(el.taskNo));
                    this.mulTotalData = initTableData(this.mulTotalData, this.dictData);
                    /* 按钮显隐逻辑 */
                    this.mulTotalData.forEach((subItem, subIndex) => {
                        subItem.hiddenEvent = [];
                        if (((subItem.orderType === 'RI') && ['IN', 'DI', 'RDI'].includes(subItem.taskType)) || subItem.projectClassify === 'LW') {
                            subItem.hiddenEvent = ['allocate'];
                        } else {
                            btnCount++;
                            subItem.hiddenEvent = [];
                        }
                        // inOutType: 出库的(OUT)  纯运输的(YS) 才显示分拨按钮
                        if (!['OUT', 'YS'].includes(subItem.inOutType)) {
                            subItem.hiddenEvent.push('allocate');
                        }
                    });
                    /* 按钮显隐逻辑 */
                    this.config.table.leftOperation = !!btnCount;
                    this.totalData = this.getTotalData(this.mulTotalData);
                }
            }).catch(() => {
                this.$refs.tablePage.sourceLoading = false;
            });
        },
        // 根据待发车列表点击参数获取上表格数据
        initDispatchList () {
            if (+this.tarSelRoot.intelligentStatus === 10) this.$refs.tablePage.$refs.searchList.onSearchChange();
            this.$refs.tablePage.targetLoading = true;
            const params = {
                dispatchNo: this.tarSelRoot.dispatchNo,
                ...this.targetTotalListPage,
                trunk: true, // 是否查询基地运单
            };
            getTargetData(params).then(async res => {
                if (res) {
                    this.realTotalTargetData = initTableData(res.data.list || [], this.dictData);
                    this.totalTargetData = this.getTotalData(this.realTotalTargetData, TARGER_TABLE_MAX_SHOW_COUNT);
                }
            }).finally(() => {
                this.$refs.tablePage.targetLoading = false;
            });
        },
        // 限制500条数据
        getTotalData (totalData, maxShowCount = MAX_SHOW_COUNT) {
            const maxCountNum = this.emergencyMaxNum || maxShowCount;
            if (totalData.length < maxCountNum) {
                return totalData;
            }
            return totalData.slice(0, maxCountNum);
        },
        // 上表格选中
        sourceSelChange (selection) {
            this.checkedSourceList = selection;
            const selctedTaskNos = this.checkedSourceList.map(item => item.taskNo);
            this.currentSourceSelectRow.checked = selctedTaskNos.includes(this.currentSourceSelectRow.taskNo);
            const moduleTable = _.get(this, '$refs.tablePage.$refs.table.$refs.moduleTable', {});
            this.checkSameLbxOrder(this.currentSourceSelectRow, moduleTable);
            // TODO:产品(李地生)说暂时取消掉
            // this.checkAssembleNo(selection, moduleTable);
        },
        // 下表格选中
        targetSelChange (selection) {
            this.cheList = selection;
            const selctedTaskNos = this.cheList.map(item => item.taskNo);
            this.currentSelectRow.checked = selctedTaskNos.includes(this.currentSelectRow.taskNo);
            const moduleTable = _.get(this, '$refs.tablePage.$refs.targetTable.$refs.moduleTable', {});
            this.checkSameLbxOrder(this.currentSelectRow, moduleTable);
            // TODO:产品(李地生)说暂时取消掉
            // this.checkAssembleNo(selection, moduleTable);
        },
        // 天猫优品的单勾选一条相同客户订单号的全部选中（展示中的数据）
        checkSameLbxOrder (row, moduleTable) {
            if (row.businessMode === 'B2B' && ['OUT', 'DO'].includes(row.taskType) && row.sourceSystem === 'CAINIAO') {
                const sameLbxOrder = moduleTable.tableData.filter(item => item.customerOrderNo === row.customerOrderNo);
                sameLbxOrder.forEach(item => {
                    moduleTable.toggleRowSelection(item, row.checked);
                });
            }
        },
        // 同一个集拼号同时下到待排车列表
        checkAssembleNo (row, moduleTable) {
            if (!row.length) return;
            const assembleNoList = [];
            for (let i = 0; i < moduleTable.tableData.length; i++) {
                const item = moduleTable.tableData[i];
                const index = row.findIndex(e => e.assembleNo === item.assembleNo);
                if (index !== -1) {
                    assembleNoList.push(item);
                }
            }
            if (assembleNoList.length) {
                assembleNoList.forEach(item => {
                    moduleTable.toggleRowSelection(item, true);
                });
            }
        },
        // 待发车列表输入框搜索事件
        searchInput (input, ev, isClick) {
            const inputVal = input.trim();
            const reg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳]$/;
            const inputValList = searchFieldSeperated(inputVal || '');
            if (inputValList.length > 100) return this.$message.warning('批量查询最多一次查询100单');
            const isAllVehicleCard = inputValList.every(v => reg.test(v));
            const isContainVehicleCard = inputValList.some(v => reg.test(v));
            if (!inputVal) {
                this.targetTotalListParams.dispatchNoList = [];
                this.targetTotalListParams.vehicleCard = '';
            } else if (isContainVehicleCard) {
                if (isAllVehicleCard) {
                    this.targetTotalListParams.dispatchNoList = [];
                    this.targetTotalListParams.vehicleCard = inputVal;
                } else {
                    return this.$message.warning('车牌号和发车单号需分开查询');
                }
            } else {
                this.targetTotalListParams.dispatchNoList = inputValList;
                this.targetTotalListParams.vehicleCard = '';
            }
            this.getTargetList(isClick);
        },
        // 上表格双击复制TK单号
        sourceCellDblclick (row, column, cell, event) {
            this.copyText(cell.children[0], cell.children[0].innerHTML, true);
        },
        // 下表格双击复制TK单号
        targetCellDblclick (row, column, cell, event) {
            this.copyText(cell.children[0], cell.children[0].innerHTML, true);
        },
        // 复制方法
        copyText (cellEl, copyText, classFlag) {
            if (cellEl.className.indexOf('el-tooltip') < 0 && classFlag) {
                return;
            }
            var input = document.createElement('input');
            input.type = 'text';
            input.value = copyText.trim();
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$message.success(`‘${input.value}’复制成功`);
        },
        // 上表格复选框勾选
        sourceSelect (selection, row) {
            this.sourceIsAllSel = false;
            this.currentSourceSelectRow = row;
        },
        // 上表格行点击
        sourceRowClick (row) {
            this.sourceIsAllSel = false;
            const moduleTable = _.get(this, '$refs.tablePage.$refs.table.$refs.moduleTable', {});
            this.checkSameLbxOrder(row, moduleTable);
        },
        // 上表格全选复选框勾选
        sourceSelectAll (selection) {
            this.sourceIsAllSel = true;
        },
        // 下表格行点击
        targetRowClick (row) {
            this.targetIsAllSel = false;
            const moduleTable = _.get(this, '$refs.tablePage.$refs.targetTable.$refs.moduleTable', {});
            this.checkSameLbxOrder(row, moduleTable);
        },
        // 下表格复选框勾选
        targetSelect (selection, row) {
            this.targetIsAllSel = false;
            this.currentSelectRow = row;
        },
        // 下表格全选复选框勾选
        targetSelectAll (selection) {
            this.targetIsAllSel = true;
        },
        // 刷新待发车数据列表
        refreshTargetList () {
            this.totalTargetData = [];
            this.targetTotalListParams.dispatchNo = this.targetTotalListParams.vehicleCard = '';
            this.getTargetList();
            this.$refs.tablePage.initActiveChange();
        },
        // 跳转可视化调度中心
        toVisualDispatchCenter () {
            this.$router.push({
                path: '/distribute/visual-dispatch-center'
            });
        },
        /* mPane回调事件 END */
        /* 搜索栏右侧按钮事件 SATRT */
        refreshList (visiable) {
            if (visiable) { this[visiable] = false; }
            this.$refs.tablePage.$refs.searchList.onSearchChange();
        },
        /* 搜索栏右侧按钮事件 END */
        /* 下表格头部操作事件 SATRT */
        mousedownTabelHeight (e) {
            this.startMove = e.clientY;
            var distance = 0;
            document.onmousemove = (ev) => {
                var thisEvent = ev || event;
                distance = this.startMove - thisEvent.clientY;
                this.endMove = distance;
                this.$refs.tablePage.targetTableEndMove(this.endMove);
            };
            document.onmouseup = () => {
                document.onmousemove = null;
                document.onmouseup = null;
                this.endMoveHeight = this.endMoveHeight + distance;
            };
        },
        // 新建发车单
        newDispOrder () {
            this.tarSelRoot = {};
            this.totalTargetData = [];
            this.realTotalTargetData = [];
        },
        // 下表格头部操作事件回调
        arraVisi (val) {
            // val有值 是移交dialog 里面选了 新建发车单 然后点击确定按钮,这个时候taskDataList等于下表格选中的数据，否则是下表格所有的数据
            this.taskDataList = val ? this.realCheList : this.realTotalTargetData;
            // carrierVisibleFlag !== 'Y'是点了排车, 但未下发供应商
            if (val || this.realTotalTargetData[0].carrierVisibleFlag !== 'Y') {
                this.arrangeSubmVisi = true;
                this.$nextTick(() => {
                    this.$refs.carScheduling.AdmittRuleForm.companyCode = this.realTotalTargetData[0].companyCode;
                    this.$refs.carScheduling.AdmittRuleForm.routeNoList = this.realTotalTargetData.filter(item => item.lineCode).map(item => item.lineCode);
                    this.$refs.carScheduling.$refs.carrierName.show();
                });
                this.flag = val;
                return false;
            }
            const flag = this.realTotalTargetData.find((item, index, arr) => item.carrierCode !== arr[0].carrierCode);
            if (flag) {
                this.$message.warning('同一承运商的运单才能排车');
                return false;
            }
            // 点击了排车，已下发供应商
            this.arrangeSubmVisi = true;
            this.carrierDisabled = true;
            const params = {
                carrierName: this.realTotalTargetData[0].carrierName,
                carrierCode: this.realTotalTargetData[0].carrierCode,
                supplierCode: this.realTotalTargetData[0].carrierCode,
                transType: this.realTotalTargetData[0].procurementChannel,
                tranName: this.realTotalTargetData[0].procurementChannelName,
                transUnitName: this.realTotalTargetData[0].transUnitName,
                transUnitCode: this.realTotalTargetData[0].transUnitCode,
                paymentTerms: this.realTotalTargetData[0].paymentTerms,
                transportContractNo: this.realTotalTargetData[0].transportContractNo,
                routeNoList: this.realTotalTargetData.filter(item => item.lineCode).map(item => item.lineCode)
            };
            this.$nextTick(() => {
                this.$refs.carScheduling.AdmittRuleForm.carrierName = this.realTotalTargetData[0].carrierName;
                this.$refs.carScheduling.AdmittRuleForm.companyCode = this.realTotalTargetData[0].companyCode;
                this.$refs.carScheduling.getAdvanceValueLists(params);
            });
        },
        // 装车排序
        // getBoxSort () {
        //     this.$prompt('', '请填写装车排序', {
        //         confirmButtonText: '确定',
        //         cancelButtonText: '取消',
        //         inputPattern: /^[1-9]\d*$/,
        //         inputType: 'number',
        //         inputValue: 1,
        //         inputErrorMessage: '请输入正整数,最大值为999',
        //         closeOnClickModal: false,
        //         beforeClose: (action, instance, done) => {
        //             if (action === 'confirm') {
        //                 if (+instance.inputValue > 999) {
        //                     return this.$message.warning('最大值为999');
        //                 }
        //                 instance.confirmButtonLoading = true;
        //                 const params = {
        //                     taskNos: this.cheList.map(item => item.taskNo), // 任务号
        //                     wlLoadSequence: instance.inputValue // 装车排序号
        //                 };
        //                 loadSeqUpdateByTaskNo(params).then((res) => {
        //                     if (+res.code === 0) {
        //                         this.cheList.forEach(e => {
        //                             e.wlLoadSequence = instance.inputValue;
        //                         });
        //                         this.realCheList.forEach(e => {
        //                             e.wlLoadSequence = instance.inputValue;
        //                         });
        //                         this.totalTargetData.forEach(e => {
        //                             e.wlLoadSequence = instance.inputValue;
        //                         });
        //                         done();
        //                     } else {
        //                         this.$message.error(res.msg);
        //                     }
        //                 }).finally(() => {
        //                     instance.confirmButtonLoading = false;
        //                 });
        //             } else {
        //                 done();
        //             }
        //         }
        //     })
        //         .then(() => {
        //             this.$message.success('装车排序成功');
        //         })
        //         .catch(() => { });
        // },

        getBoxSort (tableData) {
            this.cheList = [];
            this.totalTargetData = this.updateWlLoadSequence(JSON.parse(JSON.stringify(this.totalTargetData)), tableData);
            this.realTotalTargetData = this.updateWlLoadSequence(JSON.parse(JSON.stringify(this.realTotalTargetData)), tableData);
        },
        updateWlLoadSequence (targetData, sourceData) {
            if (targetData.length) {
                sourceData.forEach(sourceItem => {
                    const taskNos = sourceItem.taskNos.split(',');
                    taskNos.forEach(taskNo => {
                        const matchingItem = targetData.find(targetItem => targetItem.taskNo === taskNo);
                        if (matchingItem) {
                            matchingItem.wlLoadSequence = sourceItem.tableIndex;
                        }
                    });
                });
            }
            return targetData;
        },
        // 加减单确认事件回调
        async arrangeConfirmOk (dispatchNo) {
            this.totalData = [];
            this.totalTargetData = [];
            this.mulTotalData = [];
            this.realTotalTargetData = [];
            this.tarSelRoot = {};
            await this.searchChange(this.searchParams);
            this.$refs.tablePage.isCondition = true;
            this.$refs.tablePage.isShowImg = false;
            this.$refs.tablePage.input = dispatchNo;
            this.targetTree = this.tempTargetTree.filter(item => {
                return (item.dispatchNo && item.dispatchNo.indexOf(dispatchNo.trim()) !== -1);
            });
            if (this.targetTree.length === 0) {
                this.$refs.tablePage.input = null;
                this.targetTree = this.tempTargetTree;
            }
        },
        // 上 下表格移动表格参数改变回调
        totalDataChange (targetData, sourceData, scrollFlag) {
            this.mulTotalData = sourceData;
            this.realTotalTargetData = targetData;
            this.totalTargetData = this.getTotalData(targetData, TARGER_TABLE_MAX_SHOW_COUNT);
            this.totalData = this.getTotalData(sourceData);
        },
        /* 下表格头部操作事件 END */
        /* 弹窗回调事件 */
        // 排车弹窗
        arrangeSubmOk (data) {
            if (data.state) {
                if (!data.data.dispatchChannel) { // 不是快消单
                    this.arrangeSubmVisi = true;
                    this.$refs.carScheduling.saveLoading = true;
                }
                if (+this.flag === 2) {
                    const obj = {
                        flag: +this.flag,
                        oldDispatchNo: this.tarSelRoot.dispatchNo,
                        dispatchStatus: this.tarSelRoot.dispatchStatus,
                        transportList: this.realCheList,
                        preDispatchType: '1', // 调度类型  1人工调度 2算法调度 3线路调度
                        operateEntrance: 'LSP',
                        ...data.data
                    };
                    obj.transportList.forEach(item => {
                        item.carrierVisibleFlag = item.carrierVisibleFlag || 'N';
                    });
                    getTransferData(obj).then(res => {
                        if (!obj.dispatchChannel) { // 不是快消单
                            this.$refs.carScheduling.saveLoading = false;
                        }
                        if (res) {
                            if (res.msg === 'Success') {
                                this.$message({
                                    dangerouslyUseHTMLString: true,
                                    message: `<div>
                                                <span>转移成功，生成发车单号：${res.data}</span>
                                                <a id="copyTraNo" href='#' style='color: #11bec1; margin-left: 20px;'>复制</a>
                                            </div>`,
                                    type: 'success',
                                    duration: 5000
                                });
                                if (obj.vehicleCard && obj.vehicleCard !== '*') {
                                    this.getPromptTrackType(res.data);
                                }
                            } else {
                                this.$message({
                                    dangerouslyUseHTMLString: true,
                                    message: `<div>
                                                <span>${res.msg}</span>
                                                <a id="copyTraNo" href='#' style='color: #11bec1; margin-left: 20px;'>复制</a>
                                            </div>`,
                                    showClose: true,
                                    type: 'success',
                                    duration: 5000
                                });
                            }
                            const genDispatchNo = res.data.indexOf(',') < 0 ? res.data : res.data.split(',')[0];
                            document.getElementById('copyTraNo').addEventListener('click', () => {
                                this.copyText(document.body, genDispatchNo, false);
                            });
                            this.arrangeSubmVisi = false;
                            this.quickCancellationVisiable = false;
                            this.leftLists();
                        }
                    }).catch(() => {
                        if (!obj.dispatchChannel) { // 不是快消单
                            this.$refs.carScheduling.saveLoading = false;
                        }
                    });
                } else {
                    this.mainLoading = true;
                    data = Object.assign({}, data.data, this.tarSelRoot);
                    data.transportList = this.realTotalTargetData;
                    data.preDispatchType = '1';
                    data.transportList.forEach(item => {
                        item.carrierVisibleFlag = item.carrierVisibleFlag || 'N';
                    });
                    dispatchTrunkSave(data).then(res => {
                        this.mainLoading = false;
                        this.$refs.carScheduling.saveLoading = false;
                        if (res && +res.code === 0) {
                            const genDispatchNo = res.data.indexOf(',') < 0 ? res.data : res.data.split(',')[0];
                            if (data.procurementChannel === '190') {
                                this.$router.push({
                                    name: 'dispatchOrder',
                                    params: { name: '/dispatch-order', dispatchNo: genDispatchNo, carrierName: data.carrierName }
                                });
                            }
                            this.$message({
                                dangerouslyUseHTMLString: true,
                                message: `<div>
                                    <span>已保存，生成发车单号：${res.data}</span>
                                    <a id="copyNo" href='#' style='color: #11bec1; margin-left: 20px;'>复制</a>
                                </div>`,
                                type: 'success',
                                duration: 5000
                            });
                            this.arrangeSubmVisi = false;
                            if (data.vehicleCard && data.vehicleCard !== '*') {
                                this.getPromptTrackType(genDispatchNo);
                            }
                            document.getElementById('copyNo').addEventListener('click', () => {
                                this.copyText(document.body, genDispatchNo, false);
                            });
                        } else if (+res.code === 200) {
                            this.arrangeSubmVisi = false;
                            this.$message.error(res.msg || '');
                        }
                        this.leftLists();
                    }).catch(() => {
                        this.mainLoading = false;
                        this.$refs.carScheduling.saveLoading = false;
                    });
                }
            }
        },
        leftLists () {
            this.totalData = [];
            this.totalTargetData = [];
            this.mulTotalData = [];
            this.realTotalTargetData = [];
            this.$refs.tablePage.$refs.searchList.$refs.searchSet[0].search();
        },
        getPromptTrackType (dispatchNo) {
            promptTrackType(dispatchNo).then(res => {
                if (res && +res.code === 0 && res.data) {
                    if (+res.data.isZjxl === 0) {
                        this.$message.warning('该车辆不支持北斗轨迹获取，请要求司机全程打开直通宝');
                    } else if (+res.data.isZjxl === 1) {
                        this.$message.warning('该车辆可通过北斗获取轨迹');
                    }
                }
            });
        },
        /* 弹窗回调事件 */
    }
};
</script>

<style lang='less'>
@import './index.less';

.base-platoon-mPane {
    .map {
        .icon {
            display: none;
        }
    }
}
</style>
